import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArchive, faEllipsis } from '@fortawesome/free-solid-svg-icons'
import useClickAway from 'react-use/lib/useClickAway'
import useKey from 'react-use/lib/useKey'

const AvatarContainer = styled.div`
  position: relative;
  padding: 5px;
`

const AvatarWrapper = styled.button`
  position: relative;
  padding: 8px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f0f0f0;
  }
`

const DropdownMenu = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: auto;
  bottom: calc(100% - 5px);
  right: 5px;
  margin-bottom: 8px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  width: calc(100% - 10px);
  z-index: 1000;
  opacity: ${props => (props.$isOpen ? 1 : 0)};
  visibility: ${props => (props.$isOpen ? 'visible' : 'hidden')};
  transform: ${props => (props.$isOpen ? 'translateY(0)' : 'translateY(10px)')};
  transition: all 0.2s ease;
`

const EllipsisIcon = styled.div`
  padding-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
`

const DropdownItem = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #333;

  &:hover {
    background: #f5f5f5;
  }
`

interface UserAvatarProps {
  onClickArchived?: () => void
}

export default function UserAvatar({ onClickArchived }: UserAvatarProps) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  useClickAway(dropdownRef, () => {
    setIsOpen(false)
  })

  useKey('Escape', () => {
    setIsOpen(false)
  })

  return (
    <AvatarContainer ref={dropdownRef}>
      <AvatarWrapper onClick={() => setIsOpen(prev => !prev)}>
        <EllipsisIcon>
          <FontAwesomeIcon icon={faEllipsis} />
        </EllipsisIcon>
      </AvatarWrapper>

      <DropdownMenu $isOpen={isOpen}>
        {onClickArchived && (
          <DropdownItem onClick={onClickArchived}>
            <FontAwesomeIcon icon={faArchive} />
            Arquivados
          </DropdownItem>
        )}

        {/* <DropdownItem
          onClick={() => {
            navigate('/')
          }}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
          Voltar ao Gov
        </DropdownItem>

        <DropdownItem
          onClick={() =>
            signOut(auth)
              .then(() => {
                navigate('/')
              })
              .catch(error => {
                console.log('Erro ao sair', error)
              })
          }
        >
          <FontAwesomeIcon icon={faSignOutAlt} />
          Sair
        </DropdownItem> */}
      </DropdownMenu>
    </AvatarContainer>
  )
}
